import { __ } from './helpers';

/** A yup message: the translation with this id (rendered as a FormattedMessage, so in the UI language). */
export const translatedMessage = (id: string) => () => __(id);

/** The type error of a number field: an empty or unfinished input is NaN. */
export const numberTypeError = translatedMessage('errors.number_invalid');

/** The message of `.email()`, which yup gives in English ("email must be a valid email") without one. */
export const emailInvalid = translatedMessage('errors.email_invalid');

/**
 * The message yup 0.28 gave a null value in a string or number schema that is not nullable and has no own type
 * error message: its type error (for a number, about the NaN it cast null to). yup 1 gives the required message or
 * "cannot be null" instead, so the schemas this applied to keep it with `.nonNullable(nullTypeError(type))`.
 */
// Bug: the English yup text would reach the user if such a field held null; kept as it was.
export const nullTypeError =
  (type: 'string' | 'number') =>
  ({ path }: { path: string }) => {
    if (type === 'number') {
      return `${path} must be a \`number\` type, but the final value was: \`NaN\` (cast from the value \`NaN\`).`;
    }
    return `${path} must be a \`${type}\` type, but the final value was: \`null\`.\n If "null" is intended as an empty value be sure to mark the schema as \`.nullable()\``;
  };

export default nullTypeError;
